import { useApiClient } from './chunk-G2WBZTZE.js';
import { notifyError } from './chunk-Y7LXGN7T.js';
import * as React from 'react';
import { errorEnvelopeToErrorBody } from '@authe/fe-commons/api';
import { applyServerErrors } from '@authe/fe-commons/forms';

function useMutation(fn, options = {}) {
  const client = useApiClient();
  const optionsRef = React.useRef(options);
  optionsRef.current = options;
  const [data, setData] = React.useState(void 0);
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const reset = React.useCallback(() => {
    setData(void 0);
    setError(null);
    setIsLoading(false);
  }, []);
  const mutate = React.useCallback(
    async (args) => {
      const opts = optionsRef.current;
      setIsLoading(true);
      setError(null);
      const res = await fn(client, args);
      if (res.ok) {
        setData(res.data);
        setError(null);
        opts.onSuccess?.(res.data, res, args);
      } else {
        setError(res);
        opts.onError?.(res, args);
        if (opts.setFormError) applyServerErrors(errorEnvelopeToErrorBody(res), opts.setFormError);
        if (opts.notifyOnError) {
          notifyError(res, typeof opts.notifyOnError === "object" ? opts.notifyOnError : {});
        }
      }
      setIsLoading(false);
      return res;
    },
    [client, fn]
  );
  return { mutate, data, error, isLoading, reset };
}

export { useMutation };
//# sourceMappingURL=chunk-T6Y6VZ6C.js.map
//# sourceMappingURL=chunk-T6Y6VZ6C.js.map